import { RecentOrdersService } from '../../../core/services/recent-orders.service';
import { Component, OnInit } from '@angular/core';
import { MealInfo } from '@features/ordering/models/start-new-order-meal-info.model';
import { LoggingService } from '@core/services/logging.service';
import { GtmExternal, FavoriteGTMDto } from '@shared/models/configs/gtm.external';
import { GtmService } from '@core/services';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-recent-orders',
  templateUrl: './recent-orders.component.html',
  styleUrls: ['./recent-orders.component.less']
})
export class RecentOrdersComponent implements OnInit {

  public orders: MealInfo[];
  public desktopDisplayTextLimit: number;
  public mobileDisplayTextLimit: number;
  public tail: string;
  foodImageUrlPrefix: string = environment.IMG_ENDPOINT + '/food/';

  constructor(
    private recentOrdersService: RecentOrdersService,
    private logger: LoggingService,
    private gtmService: GtmService) {

  }

  ngOnInit() {
    this.recentOrdersService.getRecentOrders().subscribe(success => {
      this.orders = <MealInfo[]>success.body.valueOf();
      for (const order of this.orders) {
        order.displayText =
          order.displayText ? order.displayText.trim() : '';
        order.imageUrl = this.foodImageUrlPrefix + order.imageUrl;
      }
    }, error => {
      this.logger.logError(error);
    });
    // in chars
    this.desktopDisplayTextLimit = 38;
    this.mobileDisplayTextLimit = 26;
    this.tail = '..';
  }

  addToCart(order: MealInfo) {
    if (order.isFavorite) {
      this.sendFavoriteGtmEvent(GtmExternal.VALUE_STATUS_CLICKADD);
    }
    // Build 
    sessionStorage.setItem('gtmOrderType','reorder_previous');
    this.recentOrdersService.addToCart(order.id);
  }

  sendFavoriteGtmEvent(status: GtmExternal) {
    const favoriteGtmDto = new FavoriteGTMDto();
    favoriteGtmDto.status = status;
    this.gtmService.sendFavoriteEvent(favoriteGtmDto);
  }

}
